export function getImgSizeBySrc(src) {
    return new Promise(res => {
        const img = new Image();
        img.onload = function () {
            res({
                height: img.naturalHeight,
                width: img.naturalWidth
            });
        };
        img.src = src;
    });
}
